/**
 * Callback de Web Vitals: guarda as métricas em memória (para inspeção em dev)
 * e, em produção, pode ser trocado por um coletor (GA4, Grafana Faro etc.).
 */
export const registrarWebVital = (metric) => {
  if (!metric || typeof window === 'undefined') return;

  window.__ZOOM_WEB_VITALS__ = [...(window.__ZOOM_WEB_VITALS__ || []), metric];

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.info('[web-vitals]', metric.name, Math.round(metric.value));
  }
};

export default registrarWebVital;
